// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"7dec627c","79":"7dec627c","131":"7dec627c","261":"7dec627c","305":"7dec627c","361":"7dec627c","469":"7dec627c","842":"3f7bcc62","950":"7dec627c"}[chunkId] + ".chunk.css";
};